<ng-container *ngIf='blog'>
  <div class="blog-item rounded bg-white shadow-dark wow fadeIn">
    <div class="thumb">
      <a href="javascript:">
        <span class="category">Event</span>
      </a>
      <a href="javascript:">
        <img [src]="imageUrl ? imageUrl : 'assets/images/blog/3.svg'"  alt="blog-title" />
      </a>
    </div>
    <div class="details">
      <h4 class="my-0 title"><a href="javascript:">{{blog.fields.title}}</a></h4>
      <ul class="list-inline meta mb-0 mt-2">
        <li class="list-inline-item">06 February, 2020</li>
        <li class="list-inline-item">Koodan</li>
      </ul>
    </div>
  </div>
</ng-container>
